import { render, staticRenderFns } from "./PublicationsBySourceAndGsmHeader.vue?vue&type=template&id=2d144de7&"
import script from "./PublicationsBySourceAndGsmHeader.vue?vue&type=script&lang=js&"
export * from "./PublicationsBySourceAndGsmHeader.vue?vue&type=script&lang=js&"
import style0 from "./PublicationsBySourceAndGsmHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports